// 动画面板
import ADD_ANIMATION_ICON from '@tencent/docs-design-resources/pc/svg/floatingtoolbar_grid_insert_hover.svg';
import ANIM_PLAY_ICON from '@tencent/docs-design-resources/pc/svg/bottombar_play.svg';
import ANIM_DRAG_ICON from '@tencent/docs-design-resources/pc/svg/floatingtoolbar_drag.svg';
import ANIM_DELETE_ICON from '@tencent/docs-design-resources/pc/svg/floatingtoolbar_delete.svg';
import TENCENT_VIDEO_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_add_tool_tencentvideo.svg';
import BILIBILI_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_add_tool_bilibili.svg';
import EVERNOTE_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_add_tool_evernote.svg';
import PROCESSON_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_add_tool_processon.svg';
import CANVA_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_add_tool_canva.svg';
import MODAO_ICON from './toolbar_add_tool_modao.svg';
import MOKE_ICON from './toolbar_add_tool_moke.svg';
import CLOUDCAD_ICON from './toolbar_add_tool_cloudcad.svg';
import VIDEO_EDITOR_ICON from './video-editor.svg';
import SMART_IMAGE_ICON from './smart-image.svg';
import AI_PHOTO_MAKER_ICON from './ai-photo-maker.svg';
import DRIVE_MP3_ICON from '@tencent/docs-design-resources/pc/svg/file_drive_mp3_16.svg';
import DRIVE_MP4_ICON from '@tencent/docs-design-resources/pc/svg/file_drive_mp4_16.svg';
import DRIVE_PPT_ICON from '@tencent/docs-design-resources/pc/svg/file_drive_ppt_16.svg';
import DRIVE_DOC_ICON from '@tencent/docs-design-resources/pc/svg/file_drive_word_16.svg';
import DRIVE_EXCEL_ICON from '@tencent/docs-design-resources/pc/svg/file_drive_excel_16.svg';
import DRIVE_PDF_ICON from '@tencent/docs-design-resources/pc/svg/file_drive_pdf_16.svg';
import DRIVE_TXT_ICON from '@tencent/docs-design-resources/pc/svg/file_drive_txt_16.svg';
import DRIVE_VISIO_ICON from '@tencent/docs-design-resources/pc/svg/file_drive_visio_16.svg';
import DRIVE_XMIND_ICON from '@tencent/docs-design-resources/pc/svg/file_drive_xmind_16.svg';
import DRIVE_ZIP_ICON from '@tencent/docs-design-resources/pc/svg/file_drive_zip_16.svg';
import DRIVE_SKETCH_ICON from '@tencent/docs-design-resources/pc/svg/file_drive_sketch_16.svg';
import ADD_SHAPE_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_add_shape.svg';
import BATCH_ANIM_ICON from '@tencent/docs-design-resources/icon/desktop/svg/batch_animation_light_24.svg';
import BATCH_ADD_ANIM_ICON from '@tencent/docs-design-resources/icon/desktop/svg/batch_add_animation_light_24.svg';
import BATCH_DELETE_ANIM_ICON from '@tencent/docs-design-resources/icon/desktop/svg/batch_delete_animation_light_24.svg';

export {
    ADD_ANIMATION_ICON, ANIM_PLAY_ICON, ANIM_DRAG_ICON, ANIM_DELETE_ICON,
    TENCENT_VIDEO_ICON, BILIBILI_ICON, EVERNOTE_ICON, PROCESSON_ICON, CANVA_ICON,
    MODAO_ICON, MOKE_ICON, CLOUDCAD_ICON, VIDEO_EDITOR_ICON, SMART_IMAGE_ICON, AI_PHOTO_MAKER_ICON,
    DRIVE_MP3_ICON, DRIVE_MP4_ICON, DRIVE_PPT_ICON, DRIVE_DOC_ICON, DRIVE_EXCEL_ICON, DRIVE_PDF_ICON, DRIVE_TXT_ICON,
    DRIVE_VISIO_ICON, DRIVE_XMIND_ICON, DRIVE_ZIP_ICON, DRIVE_SKETCH_ICON,
    ADD_SHAPE_ICON, BATCH_ANIM_ICON, BATCH_ADD_ANIM_ICON, BATCH_DELETE_ANIM_ICON,
};
